import Page from './components/Page';
import Header from './components/Header'
function App() {
  return (
    <div  className="App">
      <Header/>
      <Page/>
    </div>
  );
}

export default App;
